import { render, staticRenderFns } from "./cubageConsignActual.vue?vue&type=template&id=190fcbab&"
import script from "./cubageConsignActual.vue?vue&type=script&lang=js&"
export * from "./cubageConsignActual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('190fcbab')) {
      api.createRecord('190fcbab', component.options)
    } else {
      api.reload('190fcbab', component.options)
    }
    module.hot.accept("./cubageConsignActual.vue?vue&type=template&id=190fcbab&", function () {
      api.rerender('190fcbab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/cubageConsignActual.vue"
export default component.exports